<template>
  <div :class="wrapperClass" :style="wrapperStyle">
    <SelectPrime
      :model-value="modelValue"
      :size="size"
      editable
      show-clear
      :options="options"
      :option-label="optionLabel"
      :option-value="optionValue"
      :placeholder="placeholder"
      :invalid="invalid"
      :disabled="disabled"
      :loading="loading"
      :fluid="fluid"
      :class="selectClass"
      panel-class="select-sm-panel"
      @update:model-value="$emit('update:modelValue', $event)"
      @input="handleInput"
      @change="handleChange"
    />
  </div>
</template>

<script>
import api from '@/helpers/api';

export default {
  name: 'ApiSearchableSelect',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    apiService: {
      type: Function,
      required: true
    },
    apiParams: {
      type: Object,
      default: () => ({})
    },
    searchKey: {
      type: String,
      required: true
    },
    minChars: {
      type: Number,
      default: 2
    },
    optionLabel: {
      type: String,
      default: 'label'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    placeholder: {
      type: String,
      default: 'Type to search'
    },
    size: {
      type: String,
      default: 'small'
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'select'],
  data() {
    return {
      options: [],
      searchTimeout: null,
      loading: false
    };
  },
  computed: {
    wrapperClass() {
      return this.$attrs.class || '';
    },
    wrapperStyle() {
      return this.$attrs.style || '';
    },
    selectClass() {
      return 'select-sm rounded-pill';
    }
  },
  methods: {
    handleChange(event) {
      // Only emit 'select' if the value matches one of the dropdown options
      // This ensures it only fires when user explicitly selects from dropdown, not on typing/blur
      const value = event.value;
      if (!value) {
        this.$emit('select', value);
        return;
      }
      const isSelected = this.options.some(opt => {
        const optVal = typeof opt === 'object' ? opt[this.optionValue] : opt;
        return String(optVal) === String(value);
      });
      if (isSelected) {
        this.$emit('select', value);
      }
    },
    handleInput(event) {
      const query = event.target.value;
      if (!query || query.length < this.minChars) {
        this.options = [];
        this.loading = false;
        return;
      }
      
      this.loading = true;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        try {
          const params = {
            ...this.apiParams,
            [this.searchKey]: query.toUpperCase()
          };
          const resp = await api(this, this.apiService(params), false);
          // Handle different response structures
          if (resp.data.data) {
            this.options = resp.data.data;
          } else if (Array.isArray(resp.data)) {
            this.options = resp.data;
          } else {
            this.options = [];
          }
        } catch (error) {
          console.error('ApiSearchableSelect error:', error);
          this.options = [];
        } finally {
          this.loading = false;
        }
      }, 300);
    }
  }
};
</script>
